// @flow strict

import { Spin, Tabs } from 'antd';
import { useEffect, useState } from 'react';
import { getPaymentInfo, getSubscriptionStats } from "../../../api/pricing";
import RevenueStats from './RevenueStats';
import StatsData from './SubscriptionStats';

function SubscriptionsStats() {
  const [stats, setStats] = useState({});
  const [balanceData, setBalanceData] = useState({});
  const [isLoadingStats, setIsLoadingStats] = useState(false);
  const [isLoadingBalance, setIsLoadingBalance] = useState(false);

  const fetchSubscriptionStats = async () => {
    setIsLoadingStats(true);
    try {
      const res = await getSubscriptionStats();
      if (res.data?.stats) {
        setStats(res.data.stats);
      };
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingStats(false);
    }
  };

  const fetchPaymentInfo = async () => {
    setIsLoadingBalance(true);
    try {
      const res = await getPaymentInfo();
      if (res.data?.data) {
        setBalanceData(res.data.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingBalance(false);
    }
  };

  useEffect(() => {
    fetchSubscriptionStats();
    fetchPaymentInfo();
  }, []);

  const isLoading = isLoadingStats || isLoadingBalance;

  return (
    <Spin spinning={isLoading} tip="Loading...">
      <div className="container-fluid px-3 px-md-5 py-3 pb-5 overflow-y-auto overflow-page">
        <Tabs
          items={[
            {
              label: 'Revenue Stats',
              key: 'revenue',
              children: <RevenueStats isLoading={isLoading} balanceData={balanceData} />
            },
            {
              label: 'Subscriber Stats',
              key: 'subscriber',
              children: <StatsData stats={stats} />
            },
          ]}
        />
      </div>
    </Spin>
  );
};

export default SubscriptionsStats;
